/** Paywall products test ids added for launch activation — mirrored in @test-kit PAYWALL_PRODUCTS (keep in sync). */
export const PAYWALL_PRODUCTS_TEST_IDS = {
  providerMenuStripe: 'pp-provider-stripe',
  providerMenuPaddle: 'pp-provider-paddle',
  rowMenuBtn: (id: string) => `pp-row-menu-${id}`,
  paddle: {
    addMenuItem: 'pp-provider-paddle',
    dialog: 'pp-paddle-dialog', close: 'pp-paddle-close',
    name: 'pp-paddle-name', description: 'pp-paddle-description',
    type: 'pp-paddle-type', checkoutMode: 'pp-paddle-checkout-mode',
    env: 'pp-paddle-env', envSandbox: 'pp-paddle-env-sandbox', envProduction: 'pp-paddle-env-production',
    product: 'pp-paddle-product', price: 'pp-paddle-price', submit: 'pp-paddle-submit',
    productOption: (id: string) => `pp-paddle-product-option-${id}`,
    priceOption: (id: string) => `pp-paddle-price-option-${id}`,
  },
} as const;
